import { render, staticRenderFns } from "./newShareIcon.vue?vue&type=template&id=28f49456"
import script from "./newShareIcon.vue?vue&type=script&lang=js"
export * from "./newShareIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports